<template>
	<div>
		<a-page-header style="background: #fff;" title="活动详情" />

		<div class="mainBox">
			<div class="contentBox" v-if="basicForm">
				<a-form-model ref="basicForm" :model="basicForm" :rules="basicFormRules" :label-col="labelCol" :wrapper-col="wrapperCol">
					<a-form-model-item label="活动名称" prop="activityName">
						<a-input v-model="basicForm.activityName"></a-input>
					</a-form-model-item>
					<a-form-model-item label="缩略图" prop='activityPic'>
						<a-upload name="img" listType="picture-card" class="avatar-uploader" :showUploadList="false" :action="this.$host+'/admin/index.php/admin/qiniu/uploads'"
						 @change="photoChange">
							<img v-if="basicForm.activityPic" :src="basicForm.activityPic" alt="avatar" style=" width: 21.875rem;height: 21.875rem;" />
							<div v-else>
								<a-icon :type="loading ? 'loading' : 'plus'" />
								<div class="ant-upload-text">缩略图</div>
							</div>
						</a-upload>
					</a-form-model-item>
					<a-form-model-item label="虚拟浏览量" prop="activityPv">
						<a-input v-model="basicForm.activityPv"></a-input>
					</a-form-model-item>
					<a-form-model-item label="详情" prop='activityCont'>
						<tinymce ref="activityCont" v-model="basicForm.activityCont" />
					</a-form-model-item>
					<a-form-model-item style="text-align: center;">
						<a-button type="primary" @click="basicSubmit">
							保存
						</a-button>
					</a-form-model-item>
				</a-form-model>
			</div>
		</div>
	</div>
</template>

<script>
	import tinymce from '@/components/tinymce.vue'
	export default {
		components: {
			tinymce
		},
		data() {
			return {
				id: '',
				detail: '',
				loading: false,
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 14
				},
				basicForm: {},
				basicFormRules: {
					activityName: [{
						required: true,
						message: '请填写活动名称',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
		},
		methods: {
			photoChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.basicForm.activityPic = info.file.response.data;
					this.loading = false;
				}
			},

			basicSubmit() {
				this.$refs.basicForm.validate(valid => {
					if (valid) {
						this.loading = true
						this.$http.post('/admin/index.php/admin/acit/acitSave', {
							id: this.id,
							activityName: this.basicForm.activityName,
							activityPic: this.basicForm.activityPic,
							activityPv: this.basicForm.activityPv,
							activityCont: this.basicForm.activityCont,
						}).then(res => {
							this.loading = false
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.getDetail()
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				});
			},

			getDetail() {
				this.loading = true
				this.$http.post('/admin/index.php/admin/acit/acitInfo', {
					id: this.id,
				}).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.basicForm = res.data.data
					}
				})
			},
		},
	}
</script>

<style scoped="">
	.classTitle {
		padding: 20px;
		text-align: center;
		font-size: 20px;
	}

	.avatar-uploader {
		display: flex;
		/* justify-content: center; */
	}

	.avatar-uploader>.ant-upload {
		width: 150px;
		height: 200px;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}

	.events {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.events .ant-badge-status {
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
		text-overflow: ellipsis;
		font-size: 12px;
	}

	.notes-month {
		text-align: center;
		font-size: 28px;
	}

	.notes-month section {
		font-size: 28px;
	}

	/deep/ .ant-fullcalendar-header .ant-radio-group {
		display: none
	}
</style>
